
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private ifShow: any;
  @Prop()
  private allData: any;
  @Prop()
  private jianyanIndex: any;
  @Prop()
  private jianyanData: any;
  @Watch("jianyanData", { immediate: true })
  private jianyanDataChange() {
    this.data = JSON.parse(JSON.stringify(this.jianyanData));
  }
  private data: any;
  private text: any = "";
  private typeChange() {
    if (this.data.type == "文字") {
      // 重置
      if (this.data.unit) {
        delete this.data.unit;
      }
      if (this.data.reference) {
        delete this.data.reference;
      }
      if (this.data.option) {
        delete this.data.option;
      }
    } else if (this.data.type == "数值") {
      // 重置
      if (this.data.option) {
        delete this.data.option;
      }
      this.data.unit = "";
      this.data.reference = ["", ""];
    } else if (this.data.type == "单选") {
      // 重置
      if (this.data.unit) {
        delete this.data.unit;
      }
      if (this.data.reference) {
        delete this.data.reference;
      }
      this.data.option = [];
    }
    this.forceUpdate();
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private cancel() {
    this.$emit("cancel");
  }
  private addOne() {
    if (!this.text) {
      return;
    }
    this.data.option.push(this.text);
    this.text = "";
    this.$forceUpdate();
  }
  private delOne(i: any) {
    this.data.option.splice(i, 1);
    this.$forceUpdate();
  }
  private makeSure() {
    if (!this.data.type) {
      this.$message.warning("请选择类型");
      return;
    }
    // 标题不能重复
    let hasRepeat: any = false;
    this.allData.forEach((ele: any, index: any) => {
      if (ele.name == this.data.name && index != this.jianyanIndex) {
        hasRepeat = true;
      }
    });
    if (hasRepeat) {
      this.$message.warning("当前标题已存在");
      return;
    }
    const d: any = {
      index: this.jianyanIndex,
      data: this.data,
    };
    this.$emit("update", d);
  }
}
